import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { BasicForm } from "@components/shared";

export default function MilestoneForm({
  title = "",
  description = "",
  value = "",
  multipleAward = false,
  requiresPickup = false,
  startAt = "",
  endAt = "",
  id = null,
  onSuccess = () => {},
  reqData,
  variety = "",
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onSubmit(formData) {
    const formatted = {
      ...formData,
    };

    if (
      (formData.start_at && !formData.end_at) ||
      (!formData.start_at && formData.end_at)
    ) {
      return alert("Please finish adding dates");
    }

    if (!formData.start_at || !formData.end_at) {
      formatted.ongoing = true;
    } else {
      formatted.ongoing = false;
    }

    setLoading(true);

    if (!id) return onCreate(formatted);

    return onUpdate(formatted);
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      milestone_id: id,
    };

    axios
      .put(`/milestones/${id}/`, req)
      .then(() => {
        setLoading(false);
        toast.success(t("common:updated") + "!");
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onCreate(formData) {
    const req = {
      ...reqData,
      ...formData,
    };

    axios
      .post(`/milestones/`, req)
      .then(() => {
        setLoading(false);
        toast.success(t("common:created") + "!");
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "title",
      label: t("common:title"),
      initialValue: title,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "description",
      label: `${t("common:short_description")} (${t(
        "validation:maximum_characters",
        { count: 255 }
      )})`,
      initialValue: description,
      required: true,
      textarea: true,
      schema: () =>
        Yup.string()
          .max(255, t("validation:maximum_characters", { count: 255 }))
          .required(t("validation:required")),
    },
    {
      name: "variety",
      label: t("common:variety"),
      initialValue: variety,
      required: true,
      schema: () => Yup.string().nullable().required(t("validation:required")),
      select: true,
      options: [
        { label: "Mileage", value: "1" },
        { label: "Odometer Readings", value: "2" },
        { label: "Unique Dealer Visits", value: "3" },
        { label: "Keyword Claims", value: "4" },
        { label: "Check-Ins", value: "5" },
      ],
    },
    {
      name: "value",
      label: t("common:value"),
      initialValue: value,
      required: true,
      schema: () =>
        Yup.string()
          .matches(
            /^(?=.+)(?:[1-9]\d*)?(?:(\.\d+)|(0\.\d*[1-9]+\d*))?$/,
            t("validation:numbers_only")
          )
          .required(t("validation:required")),
    },
    // {
    //   name: "multiple_award",
    //   label: "Can be awarded multiple times",
    //   initialValue: multipleAward,
    //   required: true,
    //   schema: () => null,
    //   toggle: true,
    // },
    {
      name: "requires_pickup",
      label: t("mixer:milestone:requires_pickup"),
      initialValue: requiresPickup,
      required: true,
      schema: () => null,
      toggle: true,
    },
    {
      name: "start_at",
      label: `${t("common:start_at")} (${t(
        "mixer:milestone:ongoing_instructions"
      )})`,
      initialValue: startAt,
      required: false,
      schema: () => null,
      datepicker: {},
    },
    {
      name: "end_at",
      label: `${t("common:end_at")} (${t(
        "mixer:milestone:ongoing_instructions"
      )})`,
      initialValue: endAt,
      required: false,
      schema: () => null,
      datepicker: {},
    },
  ];

  return (
    <div>
      <BasicForm
        buttonProps={{
          fullWidth: true,
        }}
        loading={loading}
        onSubmit={onSubmit}
        fields={fields}
      />
    </div>
  );
}
